module.exports = __webpack_public_path__ + "static/media/logowmotors.cf904c11.png";